import Vue from "vue";
import Component from "vue-class-component";
import { activeSex, ClientGeneralFormData, FormRules } from "@/form/Clients/General/client";

@Component
export class clientDataMix extends Vue {
    Sex = activeSex;

    clientFormData = new ClientGeneralFormData();
    rules = FormRules;

    handleBirthDateChange(value: any): void {
        this.clientFormData.birthday_date = value ? value.format('DD.MM.YYYY') : '';
    }
}
